import { apiUtils } from '../utils/apiUtils'
import downloadjs from 'downloadjs'
import moment from 'moment'

export default {
  get: function (clientid) {
    return fetch(apiUtils.integration + '/source/?clientId=' + clientid, {
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) {
        return res.json()
      } else if (res.status === 404) {
        return { error: 'Aucun fichier PLU trouvé' }
      }
      return Promise.resolve({})
    })
  },
  upload: function (file, model, clientid, code, nom, ext, pluType) {
    console.log('Sending file with : ', 'name ' + nom, '- code ' + code, ' ext - ' + ext, ' type - ' + pluType)
    const data = new FormData()
    data.append('file', file.file)
    data.append('nom', nom)
    data.append('idmodel', model)
    data.append('clientid', clientid)
    data.append('date', moment().format('YYYY-MM-DD HH:mm:ss'))
    data.append('type', pluType || 'traditionnel')
    return fetch(apiUtils.integration + '/source/', {
      method: 'POST',
      body: data
    })
      .then((res) => {
        if (res.status === 200) {
          return res.text()
            .then((xlsxId) => {
              return { xlsxId, nom: file.nom }
            })
        }
        return res.json()
          .then((body) => Promise.reject(new Error(`ERR_${res.status} - ${body.message || body.error || 'Erreur serveur'}`)))
      })
      .catch(err => Promise.reject(err instanceof Error ? err : new Error('ERR_Erreur pendant l\'envoi du fichier')))

  },
  download (filename) {
    const xlsxId = filename.xlsxId || filename.xlsx
    return fetch(apiUtils.integration + '/source/' + xlsxId, {
      method: 'GET'
    })
      .then((response) => response.blob())
      .then((blob) => {
        downloadjs(blob, `${filename.nom}.xlsx`)
      })
  },
  remove: function (file) {
    const xlsxId = file.xlsxId || file.xlsx
    return fetch(apiUtils.integration + '/source/' + xlsxId, {
      method: 'DELETE'
    }).then((response) => {
      if (!response.ok) {
        return Promise.reject(new Error('Erreur suppression : ' + response.status))
      }
    })
  }
}
